import {Injectable} from '@angular/core';
import {HttpObservable} from '../../common/http-helpers/http.wrapper';
import {PatientAccountProxy} from './patient.account.proxy';
import {
  IChangePasswordRequest,
  ICreateAccountRequest,
  ICreateAccountResponse,
  ILocatePatientResponse,
  IOneTimeCodeGenerationResponse,
  IOneTimeCodeValidationRequest,
  IOneTimeCodeValidationResponse,
  IChangePasswordResponse
} from '../login/login-internal/common/common.types';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PatientAccountService {

  constructor(private patientAccountProxy: PatientAccountProxy) { }

  public locatePatient(patientData: any): HttpObservable<ILocatePatientResponse> {
    return this.patientAccountProxy.locatePatient(patientData);
  }

  public createPatientAccount(patientDataWithAccountDetails: ICreateAccountRequest): HttpObservable<ICreateAccountResponse> {
    return this.patientAccountProxy.createPatientAccount(patientDataWithAccountDetails);
  }

  public generatePatientUserName(patientData: any): HttpObservable<string> {
    return this.patientAccountProxy.generatePatientUserName(patientData);
  }

  public getPatientUserName(patientData: any): HttpObservable<string> {
    return this.patientAccountProxy.getPatientUserName(patientData);
  }

  public generateOneTimeCode(patientData: any): HttpObservable<IOneTimeCodeGenerationResponse> {
    return this.patientAccountProxy.generateOneTimeCode(patientData);
  }

  public validateOneTimeCode(oneTimeCodeData: IOneTimeCodeValidationRequest): HttpObservable<IOneTimeCodeValidationResponse> {
    return this.patientAccountProxy.validateOneTimeCode(oneTimeCodeData);
  }

  public changePassword(userCredentials: IChangePasswordRequest): HttpObservable<IChangePasswordResponse> {
    return this.patientAccountProxy.changePassword(userCredentials);
  }
}
